import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_TICKET, CREATE_TICKET_SUCCESS, CREATE_TICKET_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* createTicket({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets`,
      method: 'POST',
      data: payload.data,
      isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_TICKET_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_TICKET_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_TICKET_ERROR, payload: error });
  }
}

export function* watchCreateTicket() {
  yield takeEvery(CREATE_TICKET, createTicket);
}

function* createTicketSaga() {
  yield all([fork(watchCreateTicket)]);
}

export default createTicketSaga;
